import { render, staticRenderFns } from "./supportMain.vue?vue&type=template&id=6688292d&"
import script from "./supportMain.vue?vue&type=script&lang=js&"
export * from "./supportMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports